import $x from '@/utils/$x';

/**
 * 消息类型列表 ID：mzW1d398
 * @param {*} params
 * @returns
 */
export async function getMessageTypeList(params) {
  return $x.post('/v1/litta/message/template/type', params);
}
/**
 * 返回任务属性 ID：mzW1d398
 * @param {*} params
 * @returns
 */
export async function getTaskTypeList(params) {
  return $x.post('/tenantReminder/taskAttribute', params);
}

/**
 * 查询标签
 * @param {*} params
 * @returns
 */
export async function getMessageMarkList(params) {
  return $x.post('/rpaBasedService/queryCommonParamList', params);
}

/**
 * 查询事件节点
 * @param {*} params
 * @returns
 */
export async function queryRpaSopTriggerEvents(params) {
  return $x.post('/rpaBasedService/queryRpaSopTriggerEvents', params);
}
/**
 * 查询事件节点
 * @param {*} params
 * @returns
 */
export async function queryResetRpaSopEvents(params) {
  return $x.post('/rpaBasedService/queryResetRpaSopEvents', params);
}
/**
 * 重置SOP触达事件
 * @param {*} params
 * @returns
 */
export async function resetRpaSopEvents(params) {
  return $x.post('/rpaBasedService/resetRpaSopEvents', params);
}

/**
 * SOP重置记录操作列表
 * @param {*} params
 * @returns
 */
export async function getResetSopRecordList(params) {
  return $x.post('/rpaBasedService/queryResetSopLog', params);
}

/**
 * 保存
 * @param {*} params
 * @returns
 */
export async function saveMessageTemplate(params) {
  return $x.post('/v1/litta/message/template/save', params);
}
/**
 * 保存
 * @param {*} params
 * @returns
 */
export async function auditMessageTemplate(params) {
  return $x.post('/v1/litta/message/template/audit', params);
}

/**
 * 更新
 * @param {*} params
 * @returns
 */
export async function updateTenantReminderDetail(params) {
  return $x.post('/tenantReminder/updateTenantReminderDetail', params);
}

/**
 * 查询
 * @param {*} params
 * @returns
 */
export async function getTenantReminderTaskByIdDetail(params) {
  return $x.post('/tenantReminder/getTenantReminderTaskById', params);
}
/**
 * delete
 * @param {*} params
 * @returns
 */
export async function deleteMessageTemplate(params) {
  return $x.post('/v1/litta/message/template/delete', params);
}

/**
 * 消息类型列表 ID：mzW1d398
 * @param {*} params
 * @returns
 */
export async function getMessageList(params) {
  return $x.post('/v1/litta/message/template/list', params);
}

/**
 * 查询-深度链接
 * @param {*} params
 * @returns
 */
export async function getDeepLinkList(params) {
  return $x.post('/v1/litta/deep/link/list', params);
}

/**
 * add-深度链接
 * @param {*} params
 * @returns
 */
export async function addDeepLink(params) {
  return $x.post('/v1/litta/deep/link/add', params);
}

/**
 * delete-深度链接
 * @param {*} params
 * @returns
 */
export async function delDeepLink(params) {
  return $x.post('/v1/litta/deep/link/delete', params);
}
/**
 * 短链支持的小程序 ID：L2kY3xMX
 * @param {*} params
 * @returns
 */
export async function deeplinkSupportMinis(params) {
  return $x.post('/v1/litta/deep/link/deeplinkSupportMinis', params);
}
/**
 * 复制微信URL
 * @param {*} params
 * @returns
 */
export async function startRoute(params) {
  return $x.post('/v1/litta/deep/link/startRoute', params);
}

/**
 * AI 记录列表 已更换接口
 * @param {*} params
 * @returns
 */
export async function getAiList(params) {
  return $x.post('/litta/order/ai/page', params);
}

/**
 * SOP触达列表
 * @param {*} params
 * @returns
 */
export async function getSopList(params) {
  return $x.post('/rpaBasedService/queryRpaSopList', params);
}

/**
 * 新增SOP触达
 * @param {*} params
 * @returns
 */
export async function newSop(params) {
  return $x.post('/rpaBasedService/saveRpaSop', params);
}

/**
 * 编辑SOP触达
 * @param {*} params
 * @returns
 */
export async function editSop(params) {
  return $x.post('/rpaBasedService/updateRpaSop', params);
}

/**
 * 删除SOP触达
 * @param {*} params
 * @returns
 */
export async function deleteSop(params) {
  return $x.post('/rpaBasedService/deleteRpaSop', params);
}

/**
 * 更新SOP触达状态
 * @param {*} params
 * @returns
 */
export async function updateSopStatus(params) {
  return $x.post('/rpaBasedService/updateRpaSopStatus', params);
}

/**
 * 触达事件列表
 * @param {*} params
 * @returns
 */
export async function touchEventList(params) {
  return $x.post('/rpaBasedService/queryRpaSopEventList', params);
}

/**
 * 新增触达事件
 * @param {*} params
 * @returns
 */
export async function newTouchEvent(params) {
  return $x.post('/rpaBasedService/saveRpaSopEvent', params);
}

/**
 * 编辑触达事件
 * @param {*} params
 * @returns
 */
export async function updateTouchEvent(params) {
  return $x.post('/rpaBasedService/updateRpaSopEvent', params);
}

/**
 * 删除触达事件
 * @param {*} params
 * @returns
 */
export async function deleteTouchEvent(params) {
  return $x.post('/rpaBasedService/deleteRpaSopEvent', params);
}

/**
 * 触达事件详情
 * @param {*} params
 * @returns
 */
export async function touchEventDetail(params) {
  return $x.post('/rpaBasedService/queryRpaSopEventDetail', params);
}
/**
 * 触达事件条件
 * @param {*} params
 * @returns
 */
export async function queryEventCodeList(params) {
  return $x.post('/rpaBasedService/queryEventCodeList', params);
}

/**
 * 查询列表信息
 * @param {*} params
 * @returns
 */
export async function queryRpaRobotList(params) {
  return $x.post('/rpaRobot/queryRpaRobotList', params);
}

/**
 * 查询机器人场景配置
 * @param {*} params
 * @returns
 */
export async function queryRobotConfig(params) {
  return $x.post('/rpaRobot/queryRobotConfig', params);
}

/**
 * 保存/更新基础机器人字段
 * @param {*} params
 * @returns
 */
export async function saveOrUpdateRobotConfig(params) {
  return $x.post('/rpaRobot/saveOrUpdateRobotConfig', params);
}

/**
 * 删除机器人
 * @param {*} params
 * @returns
 */
export async function deleteRobotConfig(params) {
  return $x.post('/rpaRobot/deleteRobotConfig', params);
}

/**
 * 分页查询内容
 * @param {*} params
 * @returns
 */
export async function h5ConfigList(params) {
  return $x.post('/link/content/list', params);
}

/**
 * 获取h5配置内容
 * @param {*} params
 * @returns
 */
export async function h5ConfigContentGet(params) {
  return $x.post('/link/content/get', params);
}

/**
 * 获取h5配置删除内容
 * @param {*} params
 * @returns
 */
export async function h5ConfigDelect(params) {
  return $x.post('/link/content/del', params);
}

/**
 * 获取h5配置新增、修改
 * @param {*} params
 * @returns
 */
export async function h5ConfigAddOrModify(params) {
  return $x.post('/link/content/addOrModify', params);
}
/** * 帕加马调度记录
 * @param {*} params
 * @returns
 */
export async function scheduleRecordPageList(params) {
  return $x.post('/schedule/admin/scheduleRecordPageList', params);
}

/**
 * 查询RPA自动回复列表
 * @param {*} params
 * @returns
 */
export async function queryRpaTextEventList(params) {
  return $x.post('/rpaAutoReply/queryRpaTextEventList', params);
}

/**
 * 更新 启用或停用 状态专用
 * @param {*} params
 * @returns
 */
export async function updateRpaTextEventStatus(params) {
  return $x.post('/rpaAutoReply/updateRpaTextEventStatus', params);
}

/**
 *删除RPA自动回复
 * @param {*} params
 * @returns
 */
export async function deleteRpaTextEvent(params) {
  return $x.post('/rpaAutoReply/deleteRpaTextEvent', params);
}

/**
 *保存/更新 RPA自动回复
 * @param {*} params
 * @returns
 */
export async function saveOrUpdateRpaTextEvent(params) {
  return $x.post('/rpaAutoReply/saveOrUpdateRpaTextEvent', params);
}
/**
 *查询RPA自动回复列表(反馈日志)
 * @param {*} params
 * @returns
 */
export async function queryRpaTextRecordList(params) {
  return $x.post('/rpaAutoReply/queryRpaTextRecordList', params);
}
/**
 *查询黑名单
 * @param {*} params
 * @returns
 */
export async function queryBlacklist(params) {
  return $x.post('/forbidden/queryForbiddenList', params);
}
/**
 *新增or更新黑名单
 * @param {*} params
 * @returns
 */
export async function saveOrUpdateBlacklist(params) {
  return $x.post('/forbidden/saveOrUpdate', params);
}
/**
 *删除黑名单
 * @param {*} params
 * @returns
 */
export async function deleteBlacklist(params) {
  return $x.post('/forbidden/deleteForbidden', params);
}
/**
 *分页查询业务操作日志
 * @param {*} params
 * @returns
 */
export async function getOperationLog(params) {
  return $x.post('/business/log/list', params);
}
/**
 * 返回支持的事件列表
 * @param {*} params
 * @returns
 */
export async function getTenantReminderEventList(params) {
  return $x.post('/tenantReminder/getTenantReminderEventList', params);
}
/**
 * 保存商家教练任务提醒数据
 * @param {*} params
 * @returns
 */
export async function saveTenantReminderEvent(params) {
  return $x.post('/tenantReminder/saveTenantReminderEvent', params);
}
/**
 * 发布商家教练任务提醒数据 ID：N2ewWPwX
 * @param {*} params
 * @returns
 */
export async function updateTenantReminderEvent(params) {
  return $x.post('/tenantReminder/updateTenantReminderEvent', params);
}
/**
 * 删除商家教练任务提醒数据 ID：wXn56JY8
 * @param {*} params
 * @returns
 */
export async function deleteTenantReminderEvent(params) {
  return $x.post('/tenantReminder/deleteTenantReminderEvent', params);
}
/**
 * 获取商家教练任务列表 ID：d8xZQaPz
 * @param {*} params
 * @returns
 */
export async function getTenantReminderList(params) {
  return $x.post('/tenantReminder/getTenantReminderList', params);
}
/**
 *消息触达--列表
 * @param {*} params
 * @returns
 */
export async function getMessageRecordList(params) {
  return $x.post('/athena/listReach', params);
}
/**
 *签名列表查询
 * @param {*} params
 * @returns
 */
export async function getALiMessageSignList(params) {
  return $x.post('/sms/manage/sign/list', params);
}
/**
 *短信模板添加
 * @param {*} params
 * @returns
 */
export async function addALiMessageTemplate(params) {
  return $x.post('/sms/manage/template/add', params);
}
/**
 *模板更新
 * @param {*} params
 * @returns
 */
export async function updateALiMessageTemplate(params) {
  return $x.post('/sms/manage/template/update', params);
}
/**
 *模板更新
 * @param {*} params
 * @returns
 */
export async function updateStatusALiMessageTemplate(params) {
  return $x.post('/sms/manage/template/status/update', params);
}
/**
 *模板列表
 * @param {*} params
 * @returns
 */
export async function getALiMessageTemplateList(params) {
  return $x.post('/sms/manage/template/list', params);
}
/**
 *短信记录
 * @param {*} params
 * @returns
 */
export async function getALiMessageRecordList(params) {
  return $x.post('/sms/manage/record/list', params);
}
/**
 *帕加马查询全体群列表信息
 * @param {*} params
 * @returns
 */
export async function queryManagedGroupChatList(params) {
  return $x.post('/wxGroupChat/queryManagedGroupChatList', params);
}
/**
 *帕加马查询全体群列表信息
 * @param {*} params
 * @returns
 */
export async function queryManagedGroupChatMemberList(params) {
  return $x.post('/wxGroupChat/queryManagedGroupChatMemberList', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function wxGroupChatTypeSwitch(params) {
  return $x.post('/wxGroupChat/wxGroupChatTypeSwitch', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function wxGroupChatRpaSwitch(params) {
  return $x.post('/wxGroupChat/wxGroupChatRpaSwitch', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
/**
 * 统一消息中心模板表单的候选值：收件端 / 服务类型门槛 / 工单开关 / 模板编码
 * 🔴 这四组值以后端枚举为唯一真相，前端不抄常量表（否则后端加一项就出现"选不到但能提交"的裂缝）
 * @returns
 */
export async function getLittaTemplateDict() {
  return $x.post('/message/template/dict', {});
}
export async function getLittaTemplateList(params) {
  return $x.post('/message/template/list', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function getLittaTemplateDetail(params) {
  return $x.post('/message/template/detail', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function delLittaTemplate(params) {
  return $x.post('/message/template/del', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function onOrOffLittaTemplate(params) {
  return $x.post('/message/template/onOrOff', params);
}
/**
 *
 * @param {*} params
 * @returns
 */
export async function addOrModifyLittaTemplate(params) {
  return $x.post('/message/template/addOrModify', params);
}

/**
 * 查询售前客服列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export async function queryCustomerServiceList(params) {
  return $x.post('/customerService/queryCustomerServiceList', params);
}
/**
 * 查询群用户
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export async function queryGroupUser(params) {
  return $x.post('/coachPersonal/queryGroupUser', params);
}
/**
 * 设置专属服务群
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export async function specifyUserServiceGroup(params) {
  return $x.post('/coachPersonal/specifyUserServiceGroup', params);
}
/**
 * 设置运动打卡消息
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export async function wxGroupChatDailySportSwitch(params) {
  return $x.post('/wxGroupChat/wxGroupChatDailySportSwitch', params);
}

// 根据教练用户ID查询教练信息
export async function searchTenantByName(params) {
  return $x.post('/tenant/user/searchTenantByName  ', params);
}

// 禁止修改群名
export async function wxGroupChatBanChangeName(params) {
  return $x.post('/wxGroupChat/wxGroupChatBanChangeName  ', params);
}

// 给群设置商家打卡群
export async function specifyTenantDailyGroup(params) {
  return $x.post('/coachPersonal/specifyTenantDailyGroup', params);
}

// 查询群二维码
export async function queryGroupQrCode(params) {
  return $x.post('/wxGroupChat/queryGroupChatCode', params);
}
// 清理告警
export async function handleWxGroupChatWarning(params) {
  return $x.post('/wxGroupChat/handleWxGroupChatWarning', params);
}

/**
 * 查询列表信息
 * @param {*} params
 * @returns
 */
export async function querySopGeneratedWithAIList(params) {
  return $x.post('/rpaBasedService/querySopGeneratedWithAIList', params);
}

/**
 * 查询RPA路由限制列表
 * @param {*} params
 * @returns
 */
export async function queryRestrictSceneLimitList(params) {
  return $x.post('/rpaRobot/queryRestrictSceneLimitList', params);
}

/**
 * 删除RPA路由限制
 * @param {*} params
 * @returns
 */
export async function deleteRestrictScene(params) {
  return $x.post('/rpaRobot/deleteRestrictScene', params);
}

/**
 * 查询RPA受限场景内容列表
 * @param {*} params
 * @returns
 */
export async function queryRestrictSceneList(params) {
  return $x.post('/rpaRobot/queryRestrictSceneList', params);
}

/**
 * 保存RPA路由限制
 * @param {*} params
 * @returns
 */
export async function saveRestrictScene(params) {
  return $x.post('/rpaRobot/saveRestrictScene', params);
}

/**
 * 重置备用BOT状态
 * @param {*} params
 * @returns
 */
export async function clearWxGroupAutoInviteRestrict(params) {
  return $x.post('/rpaRobot/clearWxGroupAutoInviteRestrict', params);
}

/**
 * 分页查询空群初始配置列表
 * @param {*} params
 * @returns
 */
export async function queryProjectConfigList(params) {
  return $x.post('/rpaRobot/queryProjectConfigList', params);
}

/**
 * 保存或更新空群初始配置
 * @param {*} params
 * @returns
 */
export async function saveOrUpdateProjectConfig(params) {
  return $x.post('/rpaRobot/saveOrUpdateProjectConfig', params);
}

/**
 * 删除空群初始配置
 * @param {*} params
 * @returns
 */
export async function deleteProjectConfig(params) {
  return $x.post('/rpaRobot/deleteProjectConfig', params);
}

/**
 * 设置空群初始配置生效
 * @param {*} params
 * @returns
 */
export async function effectiveProjectConfig(params) {
  return $x.post('/rpaRobot/effectiveProjectConfig', params);
}

/**
 * 查询RPA路由统计数据
 * @param {*} params
 * @returns
 */
export async function queryRpaRouteStatistic(params) {
  return $x.post('/rpaRobot/queryRpaRouteStatistic', params);
}
